import Button from "@/components/Button";
import useGTM from "@/hooks/useGTM";
import clsx from "clsx";
import Link from "next/link";

interface OnboardingContinueButtonProps {
  currentStepKey: string;
  currentStepIndex: number;
  onboardingStepsLength: number;
  buttonLabel: string;
  onContinue: () => void;
  currentUser: any;
  showButton: boolean;
}

/**
 * Continue button and login link component for onboarding steps.
 * Shows continue button for applicable steps and login link on welcome step.
 */
const OnboardingContinueButton = ({
  currentStepKey,
  currentStepIndex,
  onboardingStepsLength,
  buttonLabel,
  onContinue,
  currentUser,
  showButton,
}: OnboardingContinueButtonProps) => {
  const gtm = useGTM();

  return (
    <div className="OnboardingContinueButton">
      {/* CTA Button */}
      {showButton && (
        <div className={clsx("pt-4 lg:pt-8", "animate-tailwindBounce")}>
          <Button
            onClick={() => {
              onContinue();
              return null;
            }}
            label={buttonLabel}
            isFull
            theme="light"
            href={
              currentStepIndex === onboardingStepsLength - 1
                ? "/sign-up"
                : undefined
            }
            attributes={{
              "data-posthog": `onboarding-continue-button-${currentStepKey}`,
            }}
          />
        </div>
      )}

      {/* Login Link */}
      {currentStepKey === "welcome" && !currentUser && (
        <div className="mt-2 font-body text-sm font-medium text-zinc-700">
          Already have a Mob account?{" "}
          <Link
            href="/signin"
            className="underline"
            onClick={() => gtm.pushEvent("onboarding_log_in_clicked")}
            data-posthog="onboarding-login-link"
          >
            Login
          </Link>
        </div>
      )}
    </div>
  );
};

export default OnboardingContinueButton;
